import path from 'node:path';
import { fileURLToPath } from 'node:url';

/**
 * The scaffold/substitution engine lives in @ghosty/scaffolder (shared with
 * admin-app). It's bundled into the CLI's dist at build time (tsup
 * noExternal), and the templates/ tree is copied into the CLI package as a
 * build artifact (see package.json "build"). So the packed CLI is fully
 * self-contained — no @ghosty/scaffolder in node_modules at runtime.
 */
export {
  buildScaffold,
  writeScaffold,
  type ScaffoldFile,
  type ScaffoldOptions,
  type ScaffoldTokens,
  type ScaffoldTheme,
} from '@ghosty/scaffolder';

/**
 * Locate the CLI's OWN bundled templates/ directory — the copy made at build
 * time, NOT @ghosty/scaffolder's (which isn't shipped in the packed CLI).
 *
 * tsc/tsup keep dist/ one level below the package root, so:
 *   <packageRoot>/src/lib/scaffold.ts   (dev, via vitest)
 *   <packageRoot>/dist/index.js         (built — tsup flattens to one file)
 *   <packageRoot>/templates/            (build artifact, shipped via "files")
 *
 * In dev this module sits at src/lib/ → two levels up. In the bundled dist
 * it sits at dist/ → one level up. Resolve by walking up to whichever parent
 * directory actually contains templates/.
 */
export function templatesRoot(): string {
  const here = path.dirname(fileURLToPath(import.meta.url));
  // dist/index.js → ../templates ; src/lib/scaffold.ts → ../../templates
  return path.resolve(here, here.endsWith(`${path.sep}lib`) ? '../..' : '..', 'templates');
}
